var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReasonTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.839,
    height: 12.807,
    viewBox: "0 0 18.839 12.807",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:#208ce1;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-384.436 -4.641)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-205.237-13613.967l5.616,5.615,10.395-10.393",
    transform: "translate(591.087 13624.799)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReasonTickIcon);
export default __webpack_public_path__ + "static/media/reason_tick_icon.3ac412e7a9c270c7b817f3c55badabb9.svg";
export { ForwardRef as ReactComponent };